export enum YandexMetrikaEvent {
  LK_LOGIN_SIGNIN_SUBMIT = 'lk_login_signin_submit',
  LK_LOGIN_SIGNIN_SUCCESS = 'lk_login_signin_success',
  LK_LOGIN_SIGNIN_ERROR = 'lk_login_signin_error',
  LK_LOGIN_FORGOT_CLICK = 'lk_login_forgot_click',
  LK_RESETPASS_FORM_SUBMIT = 'lk_resetpass_form_submit',
  LK_RESETPASS_BACK_CLICK = 'lk_resetpass_back_click',
  LK_RESETPASS_FORM_SUCCESS = 'lk_resetpass_form_success',
  LK_RESETPASS_FORM_ERROR = 'lk_resetpass_form_error',
  LK_CABINET_DOCS_CLICK_DOWNLOAD = 'lk_cabinet_docs_click_download',
  LK_CABINET_DOCS_CLICK_RENEW = 'lk_cabinet_docs_click_renew',
  LK_CABINET_HEADER_CLICK_LOGOUT = 'lk_cabinet_header_click_logout',
  LK_CABINET_NAV_CLICK_DOCS = 'lk_cabinet_nav_click_docs',
  LK_CABINET_NAV_CLICK_MESSAGES = 'lk_cabinet_nav_click_messages',
  LK_MESSAGES_DOWNLOAD_BTN_CLICK = 'lk_messages_download_btn_click',
  LK_MESSAGES_DELETE_BTN_CLICK = 'lk_messages_delete_btn_click',
}
